import React from "react";
import clsx from "clsx";
import type { Page } from "../models/story";
import "./StoryPagePanel.css";

type Props = {
  page: Page;
  side: "left" | "right";
};

/** One column of the spread (image at top, text vertically centered in remaining space, optional page number). */
const StoryPagePanel = (props: Props) => {
  const { page, side } = props;

  const imageWrapStyle: React.CSSProperties = {
    ...(page.aspectRatio ? { aspectRatio: page.aspectRatio } : {}),
    ...(!page.showPageNumber ? { marginBottom: 0 } : {}),
  };

  return (
    <div
      className={clsx(
        "StoryPage",
        side === "left" ? "StoryPageLeft" : "StoryPageRight",
      )}
      style={!page.showPageNumber ? { paddingBottom: 0 } : undefined}
    >
      <div
        className={clsx(
          "StoryPageImageWrap",
          "StoryPageImageWrap--frame",
          !page.aspectRatio && "StoryPageImageWrap--natural",
        )}
        style={
          page.aspectRatio || !page.showPageNumber
            ? imageWrapStyle
            : undefined
        }
      >
        <img className="StoryPageImage" src={page.image} alt="" />
      </div>
      {page.showPageNumber ? (
        <div className="StoryPageTextRegion">
          <p className="StoryPageText">{page.text}</p>
        </div>
      ) : null}
      {page.showPageNumber ? (
        <span className="StoryPageNumber">{page.number}</span>
      ) : null}
    </div>
  );
};

export default StoryPagePanel;
